import { isNumber } from 'lodash';

export const mk = (value) => {
  if (!isNumber(value)) {
    return value;
  }
  if (Math.abs(value) > 999999) {
    return `${Math.sign(value) * ((Math.abs(value) / 1000000).toFixed(1))}M`;
  }
  if (Math.abs(value) > 999) {
    return `${Math.sign(value) * ((Math.abs(value) / 1000).toFixed(1))}K`;
  }
  return Math.ceil((Math.sign(value) * Math.abs(value)).toFixed(0) / 10) * 10;
};

export const round25 = (value) => {
  value = +((Math.round(value * 4) / 4).toFixed(2));
  if (Number.isInteger(value)) {
    return Math.trunc(value);
  }
  return value;
};

export const formatPercent = (value) => {
  return Math.round(value * 100);
};
